import { TOKEN, LANGUAGE } from 'utils/constants/index'

/* ==========================================================================
  Auth Related Helpers
========================================================================== */
export const getAuthToken = () => {
  return window.sessionStorage.getItem(TOKEN)
}

export const setAuthToken = (authAccessToken) => {
  window.sessionStorage.setItem(TOKEN, authAccessToken)
}

export const removeAuthToken = () => {
  window.sessionStorage.removeItem(TOKEN)
}

export const signIn = ({ token }) => {
  setAuthToken(token)
}

export const signOut = () => {
  removeAuthToken()
}

/* ==========================================================================
  Basic Utils
========================================================================== */
export const getItemFromSessionStorage = (ITEM) => {
  return sessionStorage.getItem(ITEM)
}

export const setItemInSessionStorage = (ITEM, value) => {
  return sessionStorage.setItem(ITEM, `${value}`)
}

/* ==========================================================================
  Language Related Helpers
========================================================================== */
export const setLocalLanguage = (lang) => {
  sessionStorage.setItem(LANGUAGE, lang)
}

export const getLocalLanguage = () => {
  return sessionStorage.getItem(LANGUAGE)
}
